import { useState } from 'react'

export function useActiveProjectState(persisted) {
  const [activeProjectId, setActiveProjectId] = useState(persisted?.activeProjectId ?? null)
  return { activeProjectId, setActiveProjectId }
}
